import api from "./Api";

class ModelosFaturamentoService {
  GetModelosFaturamento(payload) {
    return api.get("/v1/ModelosFaturamento/" + payload).then((response) => {
      return response.data;
    });
  }

  PostModelosFaturamento(payload) {
    return api.post("/v1/ModelosFaturamento/", payload).then((response) => {
      return response.data;
    });
  }

  PutModelosFaturamento(payload) {
    return api.put("/v1/ModelosFaturamento/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteModelosFaturamento(payload) {
    return api.delete("/v1/ModelosFaturamento/" + payload).then((response) => {
      return response.data;
    });
  }

  GetModelosFaturamentoOData(payload) {
    return api.get("/OData/ModelosFaturamento" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ModelosFaturamentoService();
